/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.11",
    versionName: "0.2.0-nightly.2026.4.11",
    versionChannel: "nightly",
    buildDate: "2026-04-11T00:13:26.797Z",
    commitHash: "3574b5db1218aa124957c1b4e24e50e2541a8cff",
};
